import React from 'react';

/**
 * The Trubon mark.
 *
 * Kept identical to the logo inside the Trubon app itself
 * (new_trubon/components/trubon/primitives.tsx). Two drawings of one brand
 * drift apart, and the ecosystem card is where most people see it first.
 *
 * Mirrors KairosisLogo's API — same sizes, same showText switch — so the two
 * can sit beside each other without special-casing either.
 *
 * The glyph is the product in one picture: a level, a candle crossing it, and
 * the crossing marked. That crossing is the moment Trubon exists to act on.
 */
export default function TrubonLogo({ size = 'md', showText = true, beta = false, className = '' }) {
  const sizes = {
    sm: { box: 'w-8 h-8', icon: 22, text: 'text-base' },
    md: { box: 'w-10 h-10', icon: 28, text: 'text-xl' },
    lg: { box: 'w-14 h-14', icon: 38, text: 'text-2xl' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        className={`${s.box} relative rounded-2xl flex items-center justify-center shrink-0`}
        style={{
          background: 'linear-gradient(135deg, #4DA3FF 0%, #007AFF 45%, #0047B3 100%)',
          boxShadow: '0 0 24px rgba(0,122,255,0.35), inset 0 1px 0 rgba(255,255,255,0.25)',
        }}
      >
        <svg width={s.icon} height={s.icon} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          {/* the level */}
          <path d="M7 21H33" stroke="#050505" strokeWidth="2.6" strokeLinecap="round" opacity="0.9" />
          {/* the candle crossing it */}
          <path d="M20 8V32" stroke="#050505" strokeWidth="2.6" strokeLinecap="round" opacity="0.9" />
          <rect x="15.6" y="13.5" width="8.8" height="13" rx="2.2" fill="#050505" opacity="0.9" />
          {/* the crossing, marked */}
          <circle cx="20" cy="21" r="2.6" fill="#4DA3FF" />
        </svg>
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-transparent to-white/10 pointer-events-none" />
      </div>
      {showText && (
        <span className={`${s.text} font-bold tracking-tight leading-none flex items-baseline gap-1.5`}>
          Trubon
          {beta && (
            <span className="rounded-[4px] border border-[#4DA3FF]/40 bg-[#007AFF]/15 px-1.5 py-[3px] text-[9px] font-semibold uppercase leading-none tracking-[0.08em] text-[#4DA3FF]">
              Beta
            </span>
          )}
        </span>
      )}
    </div>
  );
}
